<div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">
        {{ isEdit() ? ('Edit Pool ' + identifierPoolData().name) : 'Add Identifier Pool' }}
    </h5>
    <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="close()">
        <span aria-hidden="true">Close</span>
    </button>
</div>

<div class="modal-body container modal-content" ngbAutofocus>
    <form [formGroup]="form">
        <div class="pool-name-container row">
            <div class="col-lg-4">
                <app-dc-input
                        label="Pool Name"
                        id="pool-name"
                        type="text"
                        formControlName="name">
                </app-dc-input>
            </div>
        </div>
        <hr>
        <div class="groups-container" formArrayName="identifierGroups">
            <ng-container *ngIf="!loading(); else loadingTemplate">
              <ng-container *ngIf="identifierGroups().controls.length; else emptyGroups">
                <ng-container *ngFor="let group of identifierGroups().controls; index as groupIndex">
                    <div class="group" [formGroupName]="groupIndex">
                        <div class="group-info">
                            <div class="d-flex">
                                <div class="d-flex align-items-center">
                                    <span>
                                        <i>{{ group.get('id').value ? ('Group ID: ' + group.get('id').value) : ('New Group ' + (groupIndex + 1)) }}</i>
                                    </span>
                                </div>
                                <div *ngIf="isEdit()" class="d-flex align-items-center ml-3">
                                    <div class="identifier-group-status mr-2"
                                         [class.identifier-group-status-unavailable]="!group.get('available').value">
                                    </div>
                                    <span>Available</span>
                                </div>
                                <div *ngIf="isEdit()" class="d-flex align-items-center ml-3">
                                    <div class="identifier-group-status mr-2"
                                         [class.identifier-group-status-unavailable]="!group.get('allocated').value">
                                    </div>
                                    <span>Allocated</span>
                                </div>
                            </div>
                            <div>
                                <button *ngIf="!group.get('allocated').value"
                                        type="button"
                                        aria-label="Remove Group"
                                        class="btn-sm remove-group-button"
                                        (click)="removeIdentifierGroup(groupIndex)">
                                            <span aria-hidden="true">
                                                <fa-icon [icon]="trashIcon"></fa-icon> Remove Group
                                            </span>
                                </button>
                            </div>
                        </div>
                        <small *ngIf="group.hasError('duplicateType')" class="group-error">
                            <i>{{group.errors['duplicateType']}}</i>
                        </small>
                        <div class="identifiers" formArrayName="identifiers">
                            <ng-container
                                    *ngFor="let identifier of identifiers(groupIndex).controls; index as identifierIndex">
                                <div [formGroupName]="identifierIndex" class="identifier">
                                    <app-dc-select
                                            class="col-5"
                                            [label]="'identifier Type'"
                                            [id]="'identifier-type-'+groupIndex+'-'+identifierIndex"
                                            [items]="typeOptions | filterIdentifierTypes : (identifierGroups().at(groupIndex).get('identifiers').value)"
                                            [multiple]="false"
                                            [closeOnSelect]="true"
                                            [formControlName]="'type'"
                                    ></app-dc-select>
                                    <div>
                                      <app-dc-input
                                        type="text"
                                        [label]="'identifier Code'"
                                        [id]="'identifier-code-'+groupIndex+'-'+identifierIndex"
                                        [formControlName]="'code'">
                                      </app-dc-input>
                                      <span class="code-error" *ngIf="
                                      !identifiers(groupIndex)?.at(identifierIndex)?.get('code')?.errors?.required &&
                                      identifiers(groupIndex)?.at(identifierIndex)?.get('code')?.errors">Invalid code</span>
                                    </div>
                                    <button *ngIf="!group.get('allocated').value"
                                            type="button"
                                            aria-label="Remove Identifier"
                                            class="btn-sm"
                                            (click)="removeIdentifier(groupIndex, identifierIndex)">
                                            <span aria-hidden="true">
                                                <fa-icon [icon]="timesIcon"></fa-icon>
                                            </span>
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                        <button *ngIf="!group.get('allocated').value && identifiers(groupIndex).value.length < typeOptions.length"
                                type="button"
                                aria-label="Add Identifier"
                                class="add-button btn-sm"
                                (click)="addIdentifier(groupIndex)">
                            <span aria-hidden="true">
                                <fa-icon [icon]="plusIcon"></fa-icon> Add Identifier
                            </span>
                        </button>
                    </div>
                </ng-container>
              </ng-container>
              <ng-template #emptyGroups>
                <span class="no-group">No Groups</span>
              </ng-template>
            </ng-container>
            <div class="buttons-row">
                <button type="button"
                        aria-label="Add Group"
                        class="add-button btn-md btn-outline-primary"
                        (click)="addIdentifierGroup(identifierGroups().length)">
                <span aria-hidden="true">
                    <fa-icon class="mr-2" [icon]="plusIcon"></fa-icon> Add Group
                </span>
                </button>
                <button type="button"
                        aria-label="Import Groups"
                        class="add-button btn-md btn-outline-primary"
                        (click)="ImportIdentifierPools()">
                <span aria-hidden="true">
                    <fa-icon class="mr-2" [icon]="uploadIcon"></fa-icon> Import Groups
                </span>
                </button>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-primary"
            (click)="save()"
            [disabled]="form.invalid">
        {{ isEdit() ? 'Update Pool' : 'Create Pool' }}
    </button>
</div>

<ng-template #loadingTemplate>
    <app-dc-loading></app-dc-loading>
</ng-template>
{{form.invalid}}
